import { BEACONCHAIN_URL } from '../../../utils/envVars';
import { BeaconChainValidatorResponse, BeaconChainValidator } from '../types';
import { ConsolidationKeyInterface } from '../../../store/reducers/consolidate';
import { TransactionStatus } from '../../../store/actions/depositFileActions';
import { ConsolidationStatus } from '../../../store/actions/consolidationActions';
import { Action, ActionTypes } from '../../../store/actions';
import { Dispatch } from 'react';

export const getValidators = async (
  account: string,
  setLoading: (b: boolean) => void,
  dispatch: Dispatch<Action>,
  setValidatorLoadError: (b: boolean) => void
) => {
  setLoading(true);

  // beaconchain API requires two fetches - one that gets the public keys for a LUKSO address, and one that
  // queries by the validators public keys

  fetch(`${BEACONCHAIN_URL}/api/v1/validator/withdrawalCredentials/${account}`)
    .then(r => r.json())
    .then(
      ({
        data,
      }: {
        data: BeaconChainValidatorResponse[] | BeaconChainValidatorResponse;
      }) => {
        const response = Array.isArray(data) ? data : [data];
        // no validators for that user's wallet address
        if (response.length === 0) {
          dispatch({ type: ActionTypes.updateValidators, payload: [] });
          setLoading(false);
          return;
        }

        if (response.length === 0) {
          dispatch({ type: ActionTypes.updateValidators, payload: [] });
          setLoading(false);
        } else {
          // query by public keys
          const pubKeysCommaDelineated = `${response
            .slice(0, 50)
            .map(validator => validator.publickey)
            .join(',')}`;

          fetch(`${BEACONCHAIN_URL}/api/v1/validator/${pubKeysCommaDelineated}`)
            .then(r => r.json())
            .then(({ data }: { data: BeaconChainValidator[] }) => {
              const consolidationData = data.map(
                (beaconValidator): ConsolidationKeyInterface => {
                  return {
                    pubkey: beaconValidator.pubkey,
                    validatorindex: beaconValidator.validatorindex,
                    withdrawalcredentials:
                      beaconValidator.withdrawalcredentials,
                    status: beaconValidator.status,
                    effectivebalance: beaconValidator.effectivebalance,
                    isSource: false,
                    isTarget: false,
                    transactionStatus: TransactionStatus.READY,
                    consolidationStatus: ConsolidationStatus.READY_FOR_DEPOSIT,
                  };
                }
              );
              dispatch({
                type: ActionTypes.updateValidators,
                payload: consolidationData,
              });
              setLoading(false);
            })
            .catch(error => {
              console.log(error);
              setLoading(false);
              setValidatorLoadError(true);
            });
        }
      }
    )
    .catch(error => {
      console.log(error);
      setLoading(false);
      setValidatorLoadError(true);
    });
};
